import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { FoodEnergy_EndPoint } from "./ConstantsHealthCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calculer la conversion des calories en joules et kilojoules ";
const DESCRIPTION =
  "Calculer la conversion des calories en joules et kilojoules en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "r la conversion des calories en joules et kilojoules, calculatrice r la conversion des calories en joules et kilojoules, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/foodenergy/";
const apiEndpoint = `${SERVER_URL}/${FoodEnergy_EndPoint}`;

function FoodEnergyCalculator() {
  const [value, setValue] = useState(1);
  const [unitFrom, setUnitFrom] = useState("kcal");
  const [unitTo, setUnitTo] = useState("kcal");
  const [newValue, setNewValue] = useState(1);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleValueChange = (event) => {
    setValue(event.target.value);
  };

  const handleUnitFromChange = (event) => {
    setUnitFrom(event.target.value);
  };

  const handleUnitToChange = (event) => {
    setUnitTo(event.target.value);
  };

  const handleNewValueChange = (event) => {
    setNewValue(event.target.value);
  };

  const calculateFoodEnergy = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ value, unitFrom }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        if (unitTo === "kcal") {
          setNewValue(data.result.kcal);
        } else if (unitTo === "cal") {
          setNewValue(data.result.cal);
        } else if (unitTo === "J") {
          setNewValue(data.result.J);
        } else if (unitTo === "kJ") {
          setNewValue(data.result.kJ);
        }
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      setError("Erreur lors du calcul");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Convertissez facilement entre différentes unités d'énergie alimentaire.
                  Entrez une valeur et choisissez l'unité source et cible pour obtenir une conversion instantanée.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="value">
                      Valeur:
                    </label>
                    <input
                      id="value"
                      type="number"
                      value={value}
                      onChange={handleValueChange}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="unitFrom">
                      De l'unité:
                    </label>
                    <select
                      id="unitFrom"
                      value={unitFrom}
                      onChange={handleUnitFromChange}
                      className="form-control"
                      style={{ width: "75%" }}
                    >
                      <option value="kcal">Kilocalories (kcal)</option>
                      <option value="cal">Calories (cal)</option>
                      <option value="J">Joules (J)</option>
                      <option value="kJ">Kilojoules (kJ)</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="unitTo">
                      À l'unité:
                    </label>
                    <select
                      id="unitTo"
                      value={unitTo}
                      onChange={handleUnitToChange}
                      className="form-control"
                      style={{ width: "75%" }}
                    >
                      <option value="kcal">Kilocalories (kcal)</option>
                      <option value="cal">Calories (cal)</option>
                      <option value="J">Joules (J)</option>
                      <option value="kJ">Kilojoules (kJ)</option>
                    </select>
                  </div>
                  <button
                    className="btn btn-success"
                    onClick={calculateFoodEnergy}
                    disabled={isLoading}
                  >
                    {isLoading ? "Calcul en cours..." : "Calculer"}
                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {result && (
                  <div className="bg-light p-3 rounded">
                    <h3>Résultats:</h3>
                    <p><strong>Kilocalories:</strong> {result.kcal} kcal</p>
                    <p><strong>Calories:</strong> {result.cal} cal</p>
                    <p><strong>Joules:</strong> {result.J} J</p>
                    <p><strong>Kilojoules:</strong> {result.kJ} kJ</p>
                  </div>
                )}
                {error && (
                  <div className="alert alert-danger">
                    <strong>Erreur:</strong> {error}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <SecondAds />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>nergie alimentaire</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Besoins nergtiques</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoodEnergyCalculator;